import { InjectionToken } from '@angular/core';

export interface SkeletonLoaderConfig {
  /** When false, skeleton components render nothing. */
  enabled: boolean;
}

export const DEFAULT_SKELETON_LOADER_CONFIG: SkeletonLoaderConfig = {
  enabled: true,
};

export const SKELETON_LOADER_CONFIG = new InjectionToken<SkeletonLoaderConfig>(
  'SKELETON_LOADER_CONFIG',
  {
    providedIn: 'root',
    factory: () => DEFAULT_SKELETON_LOADER_CONFIG,
  },
);
